import React from 'react'
import classNames from 'classnames'
import View from 'components/View'
import './index.css'
import SquadPageFriends from 'pages/Squad/containers/Friends'
import useSelector from 'hooks/use-selector'
import isInfoLoadedSquadSelect from 'modules/squad/redux/selectors/is-info-loaded'
import SquadYourInfo from 'pages/Squad/containers/Friends/YourInfo'
import SquatPageInviteAFriendBottomButton from 'pages/Squad/containers/Friends/InviteAFriendBottomButton'
import SquadPageEmpty from 'pages/Squad/components/Empty'
import getPaddingTopSquadSelector from 'pages/Squad/selectors/get-padding-top'
import useIsMediumScreen from 'hooks/use-is-medium-screen'
import hasEmailCustomerUtil from 'utils/customer/has-email'

export default function SquadPage () {
  const isMediumScreen = useIsMediumScreen()
  const paddingTop = useSelector(getPaddingTopSquadSelector(isMediumScreen))
  const isLoaded = useSelector(isInfoLoadedSquadSelect)
  const hasEmail = hasEmailCustomerUtil()
  const debugProps = {
    isMediumScreen,
    isLoaded,
    hasEmail,
    paddingTop
  }
  logUtil('SquadPage').debug('[start] debugProps=', debugProps)

  const style = {}
  if (paddingTop) {
    style.paddingTop = paddingTop
  }
  return (
    <View
      className={classNames({
        squad: true,
        squad_empty: !hasEmail,
        'squad_padding-top': !!paddingTop
      })} style={style}
    >
      {
        !!isLoaded && (
          <>
            <SquadPageFriends />
            <SquadYourInfo />
            <SquatPageInviteAFriendBottomButton />
          </>
        )
      }
      {!hasEmail && <SquadPageEmpty />}
    </View>
  )
}
